import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import Layout from "../../components/Layout";

// 1. Define an interface for the Markdown module structure
interface MarkdownModule {
  ReactComponent: React.FC;
  attributes: {
    title?: string;
    date?: string;
    [key: string]: any;
  };
}

const posts = import.meta.glob("/src/blog/*.md");

const PostContent = styled.div`
  max-width: 700px;
  line-height: 1.6;
  margin-bottom: 200px;

  .date {
    font-size: 0.9rem;
    color: var(--color-secondary);
    margin-bottom: 1rem;
  }

  .content {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: var(--color-text);
      margin-top: 2rem;
      margin-bottom: 1rem;
    }
    h1 {
      font-size: 2rem;
    }
    h2 {
      font-size: 1.5rem;
    }
    p {
      margin-bottom: 1rem;
    }
    a {
      color: var(--color-secondary);
      text-decoration: underline;
    }
    code {
      background: var(--color-gray300);
      padding: 0.2rem 0.4rem;
      border-radius: 3px;
      font-size: 0.9rem;
    }
    pre {
      background: var(--color-gray300);
      padding: 1rem;
      border-radius: 6px;
      overflow-x: auto;
    }
  }
`;

const BlogPost: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  // Use React.FC as the type for Content
  const [Content, setContent] = useState<React.FC | null>(null);
  const [metadata, setMetadata] = useState<MarkdownModule["attributes"]>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPost = async () => {
      console.log("Available paths:", Object.keys(posts));

      setLoading(true);
      const path = `/src/blog/${slug}.md`;
      console.log("Looking for:", path);

      if (posts[path]) {
        // 2. Cast the glob import to our interface
        const module = (await posts[path]()) as MarkdownModule;

        setContent(() => module.ReactComponent);
        setMetadata(module.attributes);
      }
      setLoading(false);
    };
    loadPost();
  }, [slug]);

  console.log(loading, Content);

  if (loading) {
    return (
      <Layout pageTitle="Loading...">
        <PostContent>
          <div className="loading">Loading Post...</div>
        </PostContent>
      </Layout>
    );
  }

  if (!Content) {
    return (
      <Layout pageTitle="Post not found">
        <PostContent>
          <div>Post not found.</div>
        </PostContent>
      </Layout>
    );
  }

  return (
    <Layout pageTitle={metadata.title || "Blog Post"}>
      <PostContent>
        <div className="date">{metadata.date}</div>
        <h1>{metadata.title}</h1>

        <div className="content">
          <Content />
        </div>
      </PostContent>
    </Layout>
  );
};

export default BlogPost;
